import * as commonActions from "./common-actions"

export const RootActions = Object.assign({},

    commonActions

);